import axios from 'axios';

const api = {
  hostName:
    process.env.REACT_APP_NODE_ENV === 'production'
      ? '/apis'
      : 'http://localhost:5080/apis',

  async checkDeliveryStatus(orderId: string | undefined) {
    const response = await axios.get(
      `${this.hostName}/delivery-status/${orderId}`
    );
    return response;
  },

  async updateDeliveryStatus(
    orderId: string | undefined,
    data: any,
    hash: string | null
  ) {
    const response = await axios.patch(
      `${this.hostName}/delivery-status/${orderId}?hash=${hash}`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response;
  },
};

export default api;
